<template>
    <a :href="googleTranslateLink" rel="nofollow" target="_blank">
        <svg-icon name="external_link" class="section__external-link-icon" />{{
            $t('common.translate_with_google_translate')
        }}
    </a>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: null,
        },
    },
    computed: {
        googleTranslateLink() {
            return `https://translate.google.com/?sl=auto&tl=${this.$i18n.locale}&text=${encodeURIComponent(
                this.text
            )}`;
        },
    },
};
</script>

<style></style>
